$shm_projects_codex_prompt_edit $mol_textarea_edit
	scroll_top? 0
	field *
		^
		scrollTop <= scroll_top
	event *
		^
		scroll? <=> scroll_event? null

$shm_projects_codex_prompt $mol_textarea
	scroll_top? 0
	enter_submit? null
	enter_key? null
	plugins /
		^
		<= Enter_submit $mol_hotkey
			key *
				enter? <=> enter_key?
	Edit $shm_projects_codex_prompt_edit
		value? <=> value?
		hint <= hint
		enabled <= enabled
		spellcheck <= spellcheck
		length_max <= length_max
		selection? <=> selection?
		bring => bring
		submit? <=> submit?
		submit_with_ctrl <= submit_with_ctrl
		scroll_top? <=> scroll_top?
	View $mol_text_code
		text <= value
		render_visible_only false
		row_numb* <= row_numb*
		sidebar_showed <= sidebar_showed
		highlight <= highlight
		syntax <= syntax
		style *
			^
			transform <= scroll_transform \
